// extracted by mini-css-extract-plugin
export default {"p":"_728b3bb2fc dcd115d98c _388aa26f8c","clr":"_926f241427","dls":"_6309d2e7f1"};